export default __webpack_public_path__ + "static/media/SK.5491eb66.svg";